import { FilterOption } from "@/models/base/Filter";
import { formatFormerNamesPreview } from "@/pages/legislation/utils/ministryFilterOptions";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@capacit-com/lara-law-shared-ui";

interface FilterOptionLabelProps {
  option: FilterOption;
  /** Set when the user found this option by searching an alias name. */
  matchedViaAlias?: string;
}

export function FilterOptionLabel({
  option,
  matchedViaAlias,
}: FilterOptionLabelProps) {
  const formerNames = option.aliases ?? [];
  const { full } = formatFormerNamesPreview(formerNames);

  return (
    <div className="flex min-w-0 flex-1 flex-col gap-0.5 py-0.5">
      <span className="whitespace-normal break-words text-sm leading-snug">
        {option.label}
      </span>
      {matchedViaAlias && (
        <span className="text-xs leading-snug text-muted-foreground whitespace-normal break-words">
          Tidligere navn: {matchedViaAlias}
        </span>
      )}
      {!matchedViaAlias && formerNames.length > 0 && (
        <span className="text-xs leading-snug text-muted-foreground whitespace-normal break-words">
          Inkluderer også: {full}
        </span>
      )}
    </div>
  );
}

interface MinistryFilterHelpProps {
  className?: string;
}

export function MinistryFilterHelp({ className }: MinistryFilterHelpProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          className={className}
          aria-label="Hjælp til ministeriumfilter"
        >
          <span className="inline-flex size-4 items-center justify-center rounded-full border border-muted-foreground/40 text-[10px] font-semibold text-muted-foreground">
            ?
          </span>
        </button>
      </TooltipTrigger>
      <TooltipContent side="bottom" className="max-w-sm">
        <p>
          Ministerier kan have skiftet navn. Valget inkluderer dokumenter under
          tidligere navne.
        </p>
      </TooltipContent>
    </Tooltip>
  );
}
